import {UserAvatar, UserDropdown as AuthUserDropdown} from '@dfl/react-auth-module';
import {useUser} from '@dofleini/security';
import {Button} from 'antd';
import React, {memo, useCallback, useMemo} from 'react';
import {RiArrowDownSFill} from 'react-icons/ri';

import AuthLayout from '@/components/AuthLayout/AuthLayout';
import {options} from '@/components/UserDropdown/options';
import {useUserOptionClick} from '@/components/UserDropdown/useUserOptionClick';
import {useAuthDropdown} from '@/contexts/AuthDropdownContext';
import {useIsAdminByRoles} from '@/modules/admin/hooks/useUser';

const REACT_APP_USE_CAPTCHA = JSON.parse(process.env.REACT_APP_USE_CAPTCHA || false);

const UserDropdown = () => {
  const {isOpen, setIsOpen, view, setView} = useAuthDropdown();
  const handleClick = useUserOptionClick();
  const isAdmin = useIsAdminByRoles();
  const {user, hasPermission} = useUser();
  
  const visibleOptions = useMemo(() => options?.filter(e => {
    if (e?.permissions)
      return hasPermission(e?.permissions);
    if (e?.onlyUser)
      return !isAdmin;
    return true;
  }), [hasPermission, isAdmin]);
  
  const onVisibleChange = useCallback((value) => {
    setIsOpen(value);
    if (!value)
      setView(null);
  }, [setIsOpen, setView]);
  
  return (
    <AuthUserDropdown
      isOpen={isOpen}
      initialView={view}
      onVisibleChange={onVisibleChange}
      useCaptcha={REACT_APP_USE_CAPTCHA}
      layout={AuthLayout}
      onClick={handleClick}
      /* eslint-disable-next-line no-unused-vars */
      options={visibleOptions.map(({onlyUser, ...rest}) => rest)}
      register={false}>
      {
        user ?
          <div className={'flex items-center'}>
            <UserAvatar user={user || {}}/>
            <span className={'ml-2 hidden lg:block'}>{user.fullName}</span>
            <RiArrowDownSFill className={'hidden lg:block'}/>
          </div> :
          <div>
            <Button size={'large'} type="primary" className="bg-secondary border-secondary">Acceder</Button>
          </div>
      }
    </AuthUserDropdown>
  );
  
};

export default memo(UserDropdown);
